/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function SetCursorMessageThreadRequestFromJSON(json) {
    return SetCursorMessageThreadRequestFromJSONTyped(json, false);
}
export function SetCursorMessageThreadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        position: json['position'],
    };
}
export function SetCursorMessageThreadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        position: value.position,
    };
}
